import React  from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy  } from "@fortawesome/free-solid-svg-icons";
import gameService from '../../../../services/GameService';
import Utils from '../../../../utils/Utils';


/**
 * The download team report link class.
 */
class DownloadTeamReportsLink extends React.Component
{
    /**
     * The download reports click event handler.
     */
    onClickDownloadReports = () =>
    {
        gameService.downloadTeamReports(this.props.teamId, this.onReportsDownloaded);
    }


    /**
     * The report downloaded event handler.
     *
     * @param {*} data The data.
     */
    onReportsDownloaded = (response) =>
    {
        Utils.download(response.fileName, response.data);
    }


    /**
     * This method renders the component.
     */
    render()
    {
        return (
            <span class="fa-buttons" style={{color:"orange"}} onClick={ this.onClickDownloadReports }><FontAwesomeIcon icon = {faCopy} /></span>
        );
    }
}

export default DownloadTeamReportsLink;